import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("canvas", {
    id: _ctx.canvasID,
    role: "img",
    "aria-label": _ctx.accessiblityLabel,
    class: "chartjs"
  }, _toDisplayString(_ctx.accessiblityLabel), 9, _hoisted_1))
}